import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslationService } from '@spartacus/core';
import { observable, Subscription } from 'rxjs';
import { KbMyTicketService } from 'src/app/services/feature/mytickets/kb-my-tickets.service';

@Component({
  selector: 'app-kb-order-details-page',
  templateUrl: './kb-order-details-page.component.html',
  styleUrls: ['./kb-order-details-page.component.scss'],
  standalone: false
})
export class KbOrderDetailsPageComponent {
  myTicket: any;
  apiloaded: boolean = false;

  today: Date;
  isMobile: boolean = false;

  userList: any;
  sub = new Subscription();

  grayTotalticketsKey: string = 'common.text_account_supportTickets_page_totalResults_AllTickets';
  grayTotalticketsValue: string = undefined;

  paginationBarValue: string = undefined;
  paginationKeyForOneTicket: string = 'common.text_account_supportTickets_page_totalResultsSingleOrder';
  paginationKeyForOnlyOnePage: string = 'common.text_account_supportTickets_page_totalResultsSinglePag';
  paginationKeyForMultiplePages: string = 'common.text_account_supportTickets_page_totalResults';

  ticketForm = new FormGroup(
    {
      defaultSoldTo: new FormControl(null, [Validators.required]),
      status: new FormControl(null),
      endDateString: new FormControl(null, [Validators.required]),
      startDateString: new FormControl(null, [Validators.required]),
    },
  );
  get tickForm() {
    return this.ticketForm.controls;
  }
  data = {
    defaultSoldTo: '0001032856_0313_10_00',
    status: 'Open',
    startDateString: '2020-02-09T18:30:00+0000',
    endDateString: '2024-04-18T12:55:46+0000',
  }
  // creating variables forsorting the table with arrows
  sortByTicketId: string = undefined;
  sortByCategory: string = undefined;
  sortBySubject: string = undefined;
  sortByDateCreated: string = undefined;
  sortByDateUpdated: string = undefined;
  sortByStatus: string = undefined;
  platformId = inject(PLATFORM_ID);

  constructor(private breakpointObserver: BreakpointObserver,
    private service: KbMyTicketService,
    private trservice: TranslationService,
    private cdr: ChangeDetectorRef) {
    this.today = new Date();
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  ngOnInit() {
    if (this.isMobile) {
      this.setCustomWidth();
    }
    this.sub.add(this.service.getApi().subscribe((data: any) => {
      if (data) {
        this.myTicket = data;
        this.populateApiValues(data);
        this.apiloaded = true;
        this.cdr.detectChanges();
      }
    }))
  }
  populateApiValues(data: any) {
    const selectedSoldTo = data?.b2bUnitsWSList.find((soldTo) => { if (soldTo.uid == data?.defaultSoldTo) { return soldTo; } });
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    this.tickForm.defaultSoldTo.setValue(selectedSoldTo.uid);
    this.tickForm.startDateString.setValue(startDate);
    this.tickForm.endDateString.setValue(endDate);
    this.tickForm.status.reset();
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }
  reset() {
    this.populateApiValues(this.myTicket);
  }
  payloadCreator() {
    const payload = {
      defaultSoldTo: this.tickForm.defaultSoldTo.value,
      status: this.tickForm.status.value ?? 'New',
      startDateString: this.tickForm.startDateString.value,
      endDateString: this.tickForm.endDateString.value,
    }
    return payload;
  }
  onSubmit() {
    if (this.ticketForm.valid) {
      this.getTickets(this.payloadCreator(), 0, '');
      this.sortByDateUpdated = 'desc';
    } else {
      this.ticketForm.markAllAsTouched();
    }
  }

  getTickets(payload?, currentPage?, sortType?) {
    this.sub.add(this.service.postApi(payload, currentPage, sortType).subscribe((x: any) => {
      this.userList = x;
      this.myCustomTranslator(this.grayTotalticketsKey, 'top', x);
      if (x?.ticketsList?.length == 1) {
        this.myCustomTranslator(this.paginationKeyForOneTicket, 'one', x);
      } else if (x?.ticketsList?.length <= 5) {
        this.myCustomTranslator(this.paginationKeyForOnlyOnePage, 'onePage', x);
      } else if (x?.ticketsList?.length > 5) {
        this.myCustomTranslator(this.paginationKeyForMultiplePages, 'multiPage', x);
      }
    }));
  }

  myCustomTranslator(key: string, caller: string, apiData: any) {
    this.sub.add(this.trservice.translate(key).subscribe((translatedValue) => {
      if (caller == 'top') {
        this.grayTotalticketsValue = translatedValue.replace('{0}', apiData?.pagination?.totalResults);
      }
      if (caller == 'one') {
        this.paginationBarValue = translatedValue;
      }
      if (caller == 'onePage') {
        this.paginationBarValue = translatedValue.replace('{0}', apiData?.pagination?.totalResults);
      }
      if (caller == 'multiPage') {
        this.paginationBarValue = apiData?.startToEndRecords + translatedValue.replace('{0}', apiData?.pagination?.totalResult);
      }
      this.cdr.detectChanges();
    }));
  }


  changePageCustom(e, data) {
    this.getTickets(this.data, e, '');
  }

  sort(type) {
    if (type == 'state') {
      this.sortWithState(type);
    }
    else if (type == 'modifiedtime') {
      this.sortModifiedTime(type);
    }
    else if (type == 'ticketId') {
      this.sortTicketId(type);
    }
    else if (type == 'headline') {
      this.sortByHeadline(type);
    }
    else if (type == 'category') {
      if (this.sortByCategory == 'asc') {
        this.sortByCategory = 'desc';
      } else if (this.sortByCategory == 'desc') {
        this.sortByCategory = 'asc';
      } else {
        this.sortByCategory = 'desc';
      }
      this.removeOtherSorts(type, this.sortByCategory);
    }
    else if (type == 'byDateCreated') {
      if (this.sortByDateCreated == 'asc') {
        this.sortByDateCreated = 'desc';
      } else if (this.sortByDateCreated == 'desc') {
        this.sortByDateCreated = 'asc';
      } else {
        this.sortByDateCreated = 'desc';
      }
      this.removeOtherSorts(type, this.sortByDateCreated);
    }
  }

  sortWithState(type) {
    if (this.sortByStatus == 'asc') {
      this.sortByStatus = 'desc';
    } else if (this.sortByStatus == 'desc') {
      this.sortByStatus = 'asc';
    } else {
      this.sortByStatus = 'desc';
    }
    this.removeOtherSorts(type, this.sortByStatus);
  }

  sortModifiedTime(type) {
    if (this.sortByDateUpdated == 'asc') {
      this.sortByDateUpdated = 'desc';
    } else if (this.sortByDateUpdated == 'desc') {
      this.sortByDateUpdated = 'asc';
    } else {
      this.sortByDateUpdated = 'desc';
    }
    this.removeOtherSorts(type, this.sortByDateUpdated);
  }

  sortTicketId(type) {
    if (this.sortByTicketId == 'asc') {
      this.sortByTicketId = 'desc';
    } else if (this.sortByTicketId == 'desc') {
      this.sortByTicketId = 'asc';
    } else {
      this.sortByTicketId = 'desc';
    }
    this.removeOtherSorts(type, this.sortByTicketId);
  }

  sortByHeadline(type) {
    if (this.sortBySubject == 'asc') {
      this.sortBySubject = 'desc';
    } else if (this.sortBySubject == 'desc') {
      this.sortBySubject = 'asc';
    } else {
      this.sortBySubject = 'desc';
    }
    this.removeOtherSorts(type, this.sortBySubject);
  }

  removeOtherSorts(type, format) {
    if (type == 'byDateCreated') {
      this.sortByCategory = undefined;
      this.sortByDateUpdated = undefined;
      this.sortByStatus = undefined;
      this.sortByTicketId = undefined;
      this.sortBySubject = undefined;
    } else if (type == 'category') {
      this.sortByDateUpdated = undefined;
      this.sortByStatus = undefined;
      this.sortByTicketId = undefined;
      this.sortBySubject = undefined;
      this.sortByDateCreated = undefined;
    } else if (type == 'headline') {
      this.sortByCategory = undefined;
      this.sortByDateUpdated = undefined;
      this.sortByStatus = undefined;
      this.sortByTicketId = undefined;
      this.sortByDateCreated = undefined;
    } else if (type == 'ticketId') {
      this.sortByCategory = undefined;
      this.sortByDateUpdated = undefined;
      this.sortByStatus = undefined;
      this.sortBySubject = undefined;
      this.sortByDateCreated = undefined;
    } else if (type == 'modifiedtime') {
      this.sortByCategory = undefined;
      this.sortByStatus = undefined;
      this.sortByTicketId = undefined;
      this.sortBySubject = undefined;
      this.sortByDateCreated = undefined;
    } else if (type == 'state') {
      this.sortByCategory = undefined;
      this.sortByDateUpdated = undefined;
      this.sortByTicketId = undefined;
      this.sortBySubject = undefined;
      this.sortByDateCreated = undefined;
    }
    let payload;
    if (format == 'desc') {
      payload = { type: type + format };
    } else {
      payload = { type: type };
    }

    this.getTickets(this.data, 0, payload.type);
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}

